// @flow
import { createContext } from 'react';

export const SPUserCommitMetadataContext = createContext({});
